import { RequestTopic } from './publicApi';

/**
 * Anliegen, die im Kontaktformular zur Auswahl stehen.
 *
 * `COSTS` steht bewusst nicht mehr darin: Eine Frage nach den Kosten ist keine
 * eigene Gattung, sondern eine allgemeine Anfrage oder eine zu einer der beiden
 * Betreuungsformen. Das Anliegen selbst bleibt im System erhalten — im
 * Posteingang stehen Anfragen aus der Zeit davor weiterhin unter „Kosten /
 * Angebot" und lassen sich danach filtern.
 */
export const FORM_TOPICS: { value: RequestTopic; label: string }[] = [
  { value: 'CONTACT', label: 'Allgemeine Anfrage' },
  { value: 'CARE_24H', label: '24-Stunden-Betreuung' },
  { value: 'HOME_CARE', label: 'Stundenweise Hauswirtschaft' },
  { value: 'CAREER', label: 'Bewerbung' },
];

/**
 * Lesbare Kürzel für den Link-Parameter `?thema=`. Damit behält eine Anfrage
 * ihr Thema, wenn Besucher über eine Schaltfläche einer Unterseite auf die
 * Kontaktseite wechseln — sonst landet alles als „Allgemeine Anfrage".
 */
const SLUGS: Record<string, RequestTopic> = {
  allgemein: 'CONTACT',
  '24h': 'CARE_24H',
  hauswirtschaft: 'HOME_CARE',
  bewerbung: 'CAREER',
};

/** Kürzel für einen Link, z.B. `/kontakt?thema=24h`. */
export function topicSlug(topic: RequestTopic): string {
  const found = Object.entries(SLUGS).find(([, value]) => value === topic);
  return found ? found[0] : 'allgemein';
}

/** Link auf die Kontaktseite mit vorgewähltem Anliegen. */
export function contactLink(topic: RequestTopic): string {
  return `/kontakt?thema=${topicSlug(topic)}`;
}

/** Thema aus `?thema=` lesen; unbekannte oder fehlende Werte ⇒ [fallback]. */
export function topicFromSearch(search: string, fallback: RequestTopic = 'CONTACT'): RequestTopic {
  const slug = new URLSearchParams(search).get('thema');
  return (slug && SLUGS[slug]) || fallback;
}
